import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Button from '../Button'

const useStyles = makeStyles(theme => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  input: {
    display: 'none',
  },
}))

const FileInputWrapper = ({ buttonText, ...overrides }) => {
  const classes = useStyles()
  const fileInputConfig = {
    color: 'primary',
    size: 'medium',
    variant: 'contained',
    disabled: false,
    id: 'contained-button-file',
    ...overrides,
  }

  return (
    <div className={classes.root}>
      <input
        accept={fileInputConfig.fileType}
        className={classes.input}
        id={fileInputConfig.id}
        multiple
        onChange={fileInputConfig.onChange}
        disabled={fileInputConfig.disabled}
        type="file"
      />
      <label htmlFor={fileInputConfig.id}>
        <Button {...fileInputConfig}>{buttonText}</Button>
      </label>
    </div>
  )
}

export default FileInputWrapper
